
const initialNotifyMap = {
};

export default function (injection, Vue, otherMap = {}) {
    // &notify
    const notify = {
        _nextZIndex: 105000,
        _queue: [],
        _vcMap: {},
        _fnMap: {},
        /**
         * 添加一个notify的Vue组件
         * @param  Constructor Vue组件
         * @param  name        索引名称
         */
        extend (Constructor, name) {
            this._vcMap[name] = Vue.extend(Constructor);
            if ('alias' in Constructor) {
                this.constructNotify(Constructor.alias, this._vcMap[name]);
            }
        },
        /**
         * 构建窗体
         * @param  FrameExtended Vue构造器
         * @param  options       传入组件init方法的options
         * @return               [description]
         */
        build (FrameExtended, options) {
            let ext = new FrameExtended({
                store: injection.store,
                router: injection.router
            }).$mount();
            ext.$el.style.zIndex = notify._nextZIndex++;
            ext.close = function () {
                let that = this;
                Vue.nextTick(() => {
                    let i;
                    for (i = 0; i < notify._queue.length; i++) {
                        if (notify._queue[i] === that) {
                            notify._queue.splice(i, 1);
                            break;
                        }
                    }
                    document.body.removeChild(that.$el);
                    that.$destroy(true);
                });
            };
            notify._queue.push(ext);
            Vue.nextTick(() => {
                document.body.appendChild(ext.$el);
                // 创建完毕，调用notify的notifyCreated
                if ('notifyCreated' in FrameExtended.sealedOptions) {
                    Vue.nextTick(() => {
                        let defaultOptions =
                            ('defaultOptions' in FrameExtended.sealedOptions)
                                ? (FrameExtended.sealedOptions.defaultOptions()) : {};
                        FrameExtended.sealedOptions.notifyCreated.call(ext, Object.assign(defaultOptions, options));
                        Vue.nextTick(() => {
                            notify.adjustPosition(ext);
                        });
                    });
                }
            });
        },
        /**
         * 使notify窗体靠右，并计算对应top
         * @param  {[type]} frameInstance [description]
         * @return {[type]}               [description]
         */
        adjustPosition (frameInstance) {
            let defaultTop = 55;
            setTimeout(() => {
                frameInstance.$el.querySelector('.notify-area__warp').classList.add('show');
            }, 100);

            const $lastNotify = notify._queue[notify._queue.length - 2];
            if ($lastNotify) {
                const rect = $lastNotify.$el.getBoundingClientRect();
                defaultTop = rect.top + rect.height + 10;
            } else {
                defaultTop = 84;
            }

            frameInstance.$el.style.top = `${defaultTop}px`;
        },
        constructNotify (alias, FrameExtended) {
            notify._fnMap[alias] = function (options) {
                return notify.build(FrameExtended, options);
            };
            Object.defineProperty(notify, alias, {
                get () {
                    return notify._fnMap[alias];
                }
            });
        }
    };

    Object.defineProperties(injection, {
        notify: {
            get () {
                return notify;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $notify: {
            get () {
                return notify;
            }
        }
    });

    Object.keys(otherMap).forEach(val => {
        initialNotifyMap[val] = otherMap[val];
    });

    for (let i in initialNotifyMap) {
        notify.extend(initialNotifyMap[i], i);
    }
}
